import { render, staticRenderFns } from "./upgrade-software.vue?vue&type=template&id=115ff93a&scoped=true"
import script from "./upgrade-software.vue?vue&type=script&lang=js"
export * from "./upgrade-software.vue?vue&type=script&lang=js"
import style0 from "./upgrade-software.vue?vue&type=style&index=0&id=115ff93a&prod&lang=scss&scoped=true"
import style1 from "./upgrade-software.vue?vue&type=style&index=1&id=115ff93a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115ff93a",
  null
  
)

export default component.exports